/* eslint-disable ember/no-computed-properties-in-native-classes */
import { action, computed } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismSelectInput, PrismTooltip } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { ACCESS_RIGHTS } from 'lumen/utils/constants/general-constants';

interface SettingsHotelAccessFormsAccessRightsDropdownSignature {
  Args: {
    cellData: unknown;
    row: unknown;
  };
}

export default class SettingsHotelAccessFormsAccessRightsDropdown extends Component<SettingsHotelAccessFormsAccessRightsDropdownSignature> {
  @service declare intl: Services['intl'];

  rights = ACCESS_RIGHTS.map((right) => ({
    key: right.key,
    label: this.intl.t(right.value),
  }));

  selectedValue = undefined;

  @computed('args.row.{isSelected,isLocked}')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isDisabled() {
    if (this.args.row !== undefined) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return this.args.row.isSelected || this.args.row.isLocked;
    }

    return false;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get placeholder() {
    return this.intl.t(
      // @ts-expect-error: Incorrect type
      ACCESS_RIGHTS.filter((item) => item.key === this.args.cellData)[0].value,
    );
  }

  @computed('args.cellData', 'rights.[]')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get selectedRight() {
    return this.rights.find((item) => item.key === this.args.cellData);
  }

  constructor() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line prefer-rest-params
    super(...arguments);
    // @ts-expect-error: Incorrect type
    this.selectedValue = this.args.cellData;
  }

  @action
  // @ts-expect-error: Incorrect type
  select(option): void {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    this.args.row.onRightsChange({
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
      value: option.key,
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      subscription: this.args.row.subscriptionId,
    });
  }

  <template>
    <div class="access-rights-dropdown flex flex-col">
      {{! @glint-expect-error: Incorrect type }}
      {{#if @row.isSelected}}
        <PrismTooltip
          @side="top"
          @text={{t
            "settings.hotel_access.edit.multiple_selections.tooltip_text"
          }}
        />
        <PrismSelectInput
          @disabled={{this.isDisabled}}
          @onChange={{this.select}}
          @options={{this.rights}}
          @placeholder={{this.placeholder}}
          @value={{this.selectedRight}}
        />
      {{else}}
        <PrismSelectInput
          @disabled={{this.isDisabled}}
          @onChange={{this.select}}
          @options={{this.rights}}
          @placeholder={{this.placeholder}}
          @value={{this.selectedRight}}
        />
      {{/if}}
    </div>
  </template>
}
